import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export interface IPagination {
  page: number;
  pageSize: number;
  total?: number;
  totalPages?: number;
  time?: Date;
}

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginatorComponent {
  @Input() range = 2;
  @Input() set pagination(pagination: IPagination) {
    this._pagination = pagination;
    this.createPages();
  }
  get pagination(): IPagination {
    return this._pagination;
  }
  @Output() pageChanged = new EventEmitter<number>();
  public pages: number[] = [];
  private _pagination: IPagination = {
    page: 1,
    totalPages: 1,
    total: 0,
    pageSize: 0,
  };

  protected createPages() {
    this.pages = [];

    // debugger;
    let min = this.pagination.page - this.range;
    let max = this.pagination.page + this.range;
    if (min < 1) {
      max = max - min + 1;
      min = 1;
      max = Math.min(this.pagination.totalPages, max);
    }
    if (max > this.pagination.totalPages) {
      min = min - (max - this.pagination.totalPages);
      min = Math.max(1, min);
      max = this.pagination.totalPages;
    }
    // min = Math.min(1, min);
    // max = Math.max(this.pagination.totalPages, max);
    for (let i = min; i <= max; i = i + 1) {
      this.pages.push(i);
    }
    // logger.debug({
    //   page: this.pagination.page,
    //   min,
    //   max,
    //   pages: this.pages,
    // });
  }

  public goPage(index: number) {
    const page = Math.max(1, Math.min(index, this.pagination.totalPages));
    this.pageChanged.emit(page);
    this.createPages();
  }

  public get isPreviousPageEnabled(): boolean {
    return this.pagination.page > 1;
  }

  public get isNextPageEnabled(): boolean {
    return this.pagination.page < this.pagination.totalPages;
  }

  public goPreviousPage() {
    this.goPage(this.pagination.page - 1);
  }

  public goNextPage() {
    this.goPage(this.pagination.page + 1);
  }

  public goFirstPage() {
    this.goPage(1);
  }

  public goLastPage() {
    this.goPage(this.pagination.totalPages);
  }

  public trackByFn(index) {
    return index;
  }
}
